// @flow
export const PROCESS_PAYMENT = 'stripe/PROCESS_PAYMENT'
export const PROCESS_PAYMENT_SUCCESS = 'stripe/PROCESS_PAYMENT_SUCCESS'
export const PROCESS_PAYMENT_FAILED = 'stripe/PROCESS_PAYMENT_FAILED'
export const SHOW_LOADER = 'stripe/SHOW_LOADER'
export const STRIPE_ERROR = 'stripe/STRIPE_ERROR'
export const ADD_PAYMENT_INTENT = 'stripe/ADD_PAYMENT_INTENT'

const stripe = (
  state = {
    isProcessing: false,
    paymentIntent: {}
  },
  action
) => {
  switch (action.type) {
    case SHOW_LOADER:
    case PROCESS_PAYMENT:
      return {
        ...state,
        isProcessing: true,
        error: false,
        success: false
      }

    case PROCESS_PAYMENT_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        success: true,
        error: false
      }
    case STRIPE_ERROR:
    case PROCESS_PAYMENT_FAILED:
      return {
        ...state,
        isProcessing: false,
        error: action.reason,
        success: false
      }

    case ADD_PAYMENT_INTENT:
      return {
        ...state,
        paymentIntent: action.paymentIntent
      }
    default:
      return state
  }
}

export const stripeRequest = ({ token, booking, useStripe }) => {
  return {
    type: PROCESS_PAYMENT,
    payload: {
      token,
      booking,
      useStripe
    }
  }
}

export const showLoader = () => {
  return {
    type: SHOW_LOADER
  }
}

export const stripeError = ({ message }: any) => ({ type: STRIPE_ERROR, reason: message })

export const addPaymentIntent = ({ paymentIntent }: any) => ({
  type: ADD_PAYMENT_INTENT,
  paymentIntent
})

export default stripe
export * from './sagas.js'



// WEBPACK FOOTER //
// ./src/ducks/stripe/index.js